export enum ExpenseTypeEnum {
  All = 'All',
  Supplier = 'Supplier',
  Employee = 'Employee',
  Company = 'Company'
} 